/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationCloudAccountSummaryResponse {
    getFixupPrototypeFunction() { return CostOptimizationCloudAccountSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationCloudAccountSummaryResponse>): CostOptimizationCloudAccountSummaryResponse {
        let obj = Object.assign(new CostOptimizationCloudAccountSummaryResponse(), model);
        CostOptimizationCloudAccountSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationCloudAccountSummaryResponse>): CostOptimizationCloudAccountSummaryResponse {
        if (!model) return null;
        return CostOptimizationCloudAccountSummaryResponse.newInstance(<CostOptimizationCloudAccountSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationCloudAccountSummaryResponse) {
        if (!obj) return;

        models.CostOptimizationCloudAccountSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationCloudAccountSummaryResponse): boolean {
        Object.setPrototypeOf(obj, CostOptimizationCloudAccountSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.account_summary) {
            for (let val of this.account_summary) {
                models.AccountSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Total Count
     */
    total_count: number;

    /**
     * Page Count
     */
    page_count: number;

    /**
     * Total Saving Percentage
     */
    overall_savings_percentage: string;

    /**
     * Potential cost savings total info
     */
    potential_cost_savings_total_info: string;

    /**
     * Potential cost savings total
     */
    potential_cost_savings_total: string;

    account_summary: Array<models.AccountSummary>;

}
